/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Export_FailedInputs */

const vi_movement_breakdown_export_failed = /** @type {(inputs: Movement_Breakdown_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel thất bại`)
};

/**

* @param {Movement_Breakdown_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_export_failed = /** @type {((inputs?: Movement_Breakdown_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_export_failed(inputs)
});